import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { OverviewItem } from '../index';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';

export default function Overview() {
  const classes = useStyles();
  const chartColor = [
    colors.blue[700],
    colors.orange[500],
    colors.lightBlue[400],
    colors.green[500]
  ];

  const dashboard = useSelector(({ dashboard }) => dashboard.data);
  const [overview, setOverview] = useState([]);

  useEffect(() => {
    if (dashboard) {
      const _overview = dashboard.overview.map((item, index) => {
        return {
          name: item.name,
          backgroundColor: chartColor[index],
          amount: item.amount,
          fee: item.fee
        };
      });
      setOverview(_overview);
    }
  }, [dashboard, chartColor]);

  return (
    <Grid
      className={classes.container}
      container
      spacing={3}
    >
      {dashboard &&
        overview.map(ov => {
          return (
            <Grid
              item
              key={ov.name}
              lg={3}
              sm={6}
              xs={12}
            >
              <OverviewItem
                cardColor={ov.backgroundColor}
                qrData={ov}
              />
            </Grid>
          );
        })}
    </Grid>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(0)
  }
}));
